<script setup lang="ts">
  import { Text } from "@ui-kit";

  const { title } = defineProps<{ title: string }>();
</script>

<template>
  <div class="section">
    <Text font="body-bold-16">{{ title }}</Text>
    <slot />
  </div>
</template>

<style scoped>
  .section {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
</style>
